import React, { Fragment } from "react";

//Componentes
import TimeOut from "./TimeOut";
import VerifyToken from "./VerifyToken";

const ContainerMiddleware = () => {
    
    return (
        <Fragment>
            <TimeOut />
            <VerifyToken />
        </Fragment>
    );
};

export default ContainerMiddleware;
